import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCK = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M24.933 24.999H25v-.067l-.067.067Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 13.043V0h-.004C11.19.002 0 11.194 0 25h13.043v-7.345L20.389 25h4.545l.067-.067V20.39l-7.345-7.345H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M12.648 3.262a25.119 25.119 0 0 0-9.387 9.387V25h6.521V9.784H25V3.262H12.648Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m25 21.927-8.883-8.882h-3.074L25 25.001v-3.074Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m33.696 25 .462 1.423h1.497l-1.21.88.462 1.424-1.211-.88-1.211.88.462-1.424-1.21-.88h1.496L33.696 25ZM27.547 27.547l1.334.679 1.058-1.058-.234 1.478 1.333.68-1.478.233-.234 1.479-.68-1.334-1.478.234 1.059-1.058-.68-1.333ZM25 33.695l1.423-.463v-1.496l.88 1.21 1.424-.462-.88 1.21.88 1.212-1.424-.463-.88 1.21v-1.496L25 33.695ZM27.547 39.845l.68-1.334-1.059-1.058 1.479.234.679-1.334.234 1.479 1.478.234-1.333.68.234 1.478-1.058-1.059-1.334.68ZM33.696 42.392l-.463-1.424h-1.496l1.21-.88-.462-1.423 1.21.88 1.212-.88-.463 1.424 1.21.88h-1.496l-.462 1.423ZM39.845 39.845l-1.334-.68-1.058 1.059.234-1.479-1.334-.68 1.479-.233.234-1.479.68 1.334 1.477-.234-1.058 1.058.68 1.334ZM42.391 33.695l-1.423.462v1.497l-.88-1.21-1.423.462.88-1.211-.88-1.211 1.423.462.88-1.21v1.496l1.423.463ZM39.845 27.547l-.68 1.333 1.059 1.059-1.479-.235-.68 1.334-.233-1.479-1.479-.234 1.334-.679-.234-1.478 1.058 1.058 1.334-.68Z"
}));
FlagCK.displayName = 'FlagCK';
export default withFlagWrapper(FlagCK);
//# sourceMappingURL=index.js.map